import React from 'react';
import isArray from 'lodash/isArray';
import mergeWith from 'lodash/mergeWith';
import { initialAppState } from './initialState';

/**
 * App Context. This context is meant to store anything and is used pervasively throughout the app.
 * all state updates simply do a deep copy with existing state unless the action is `reset`
 */
export const AppStateContext = React.createContext(initialAppState);
// eslint-disable-next-line
export const AppStateDispatchContext = React.createContext<React.Dispatch<any>>(() => {});

// eslint-disable-next-line
export const useStateDispatch = () => React.useContext<React.Dispatch<any>>(AppStateDispatchContext);
export const useStateValue = () => React.useContext(AppStateContext);

// Reducer for the App state.
export const reducer = (state, action) => {
  // Exception for empty arrays not replacing arrays.
  function customizer(objValue, srcValue) {
    if (isArray(objValue) && isArray(srcValue) && !srcValue.length) {
      return [];
    }
  }

  const deepCopy = {
    ...mergeWith(state, action, customizer),
  };

  if (action === 'reset') {
    return {
      ...initialAppState,
    };
  } else {
    return deepCopy;
  }
};

/**
 * Modal Context.
 */
export const ModalContext = React.createContext();
export const useModalContext = () => React.useContext(ModalContext);
